import React from 'react';
import { RouteObject } from 'react-router-dom';
import Landing from './components/Landing';
import DetailLanding from './components/detail/Landing';

export interface mxReadsRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: mxReadsRoute[];
}

export const mxReadsRoutes: mxReadsRoute[] = [
  {
    path: '/mx/meterread/manual-meter',
    element: <Landing />,
  },
  {
    path: '/mx/reads/detail/:runId',
    element: <DetailLanding />,
  },
  {
    path: '/mx/reads/detail/:type/:runId',
    element: <DetailLanding />,
  },
];